import { Outlet, createFileRoute } from '@tanstack/react-router';

/**
 * Layout do módulo Pipeline (Portal Vega, Bloco 1 — DEC-060). Só monta o <Outlet/>; o shell
 * (sidebar/topbar) já vem do __root.tsx. As abas do módulo vivem como filhas: pipeline.index.tsx
 * (Funil — board), pipeline.tarefas.tsx, pipeline.originacao.tsx, pipeline.dashboards.tsx.
 * Convenção escolhida: flat-com-ponto (pipeline.<aba>.tsx), a mesma família de nomes já usada
 * pelo projeto (routes/<nome>.tsx), sem introduzir diretórios novos.
 */
export const Route = createFileRoute('/pipeline')({
  component: () => <Outlet />,
});
